import React from 'react';
import { Navigation } from '../components/Navigation';
const BRIEF_IMAGES = ['https://cdn.magicpatterns.com/uploads/4zwEdjtbPanc5aXFmubtqZ/Nisha_1_(2).jpg', 'https://cdn.magicpatterns.com/uploads/8KLB1Jo4geSquFjyzpsB7j/Nisha_2_(2).jpg'];
export function BriefPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-39">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border-2 border-[#ef3e23] shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-40">
        <Navigation activePath="/brief" data-id="element-41" />
        <main className="flex-1 px-4 md:px-16 py-8 space-y-12 md:space-y-24" data-id="element-42">
          {/* Hero Section */}
          <section className="max-w-4xl" data-id="element-43">
            <h1 className="text-[clamp(2.5rem,8vw,8rem)] font-semibold leading-[0.95] md:leading-[0.9] tracking-[-0.04em] text-ink" data-id="element-44">
              The Brief
              <span className="text-accent inline-block w-[0.15em] h-[0.15em] rounded-full ml-[0.05em] mb-[0.1em]" data-id="element-45" />
            </h1>
            <p className="mt-6 text-lg md:text-xl leading-[1.6] text-ink font-medium max-w-2xl" data-id="element-46">
              I'm looking for someone like this - the hands and the father
              figure with a similar background. This is just an example to give
              you a rough idea I mocked up on AI.
            </p>
          </section>

          {/* Reference Images */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-47">
            {BRIEF_IMAGES.map((src, i) => <div key={i} className="rounded-[1rem] md:rounded-[2rem] overflow-hidden border border-black/5 shadow-xl bg-white" data-id="element-48">
                <img src={src} alt={`Reference ${i + 1}`} className="w-full h-auto block" data-id="element-49" />
              </div>)}
          </section>

          {/* The Blurb */}
          <section className="bg-white rounded-[1.5rem] p-8 md:p-16 border border-black/5 space-y-8" data-id="element-50">
            <div className="space-y-4" data-id="element-51">
              <span className="bg-accent text-white px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-full w-fit" data-id="element-52">
                Project Narrative
              </span>
              <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-ink" data-id="element-53">
                The Blurb (WIP)
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 text-ink/80 text-lg leading-relaxed" data-id="element-54">
              <div className="space-y-6" data-id="element-55">
                <p data-id="element-56">
                  In 1995, Rasleen lived two lives. In one, she was the dutiful
                  daughter of a proud Sikh household, moving under the watchful,
                  heavy gaze of a strict father whose word was law. In the
                  other, she was a girl in love with Jamie – a white boy who
                  represented everything her family feared.
                </p>
                <p data-id="element-57">
                  Their relationship was a betrayal of tradition and honour. A
                  secret romance, built on stolen moments, and the terrifying
                  knowledge of what her father would do if he ever found out.
                </p>
                <p data-id="element-58">
                  Then overnight, Jamie vanishes, leaving Rasleen devastated and
                  heartbroken. For thirty years she believed Jamie abandoned her
                  and simply walked away. No goodbye, no explanation, no
                  nothing.
                </p>
              </div>
              <div className="space-y-6" data-id="element-59">
                <p data-id="element-60">
                  Now her father is dead. Rasleen is happily married with two
                  children and a wonderful life. Clearing out her father's desk
                  drawer, she stumbles across a clue to what really happened to
                  Jamie Smith all those years ago.
                </p>
                <p data-id="element-61">
                  Set against the grey, rain-soaked backdrop of the Northern
                  English town of Darlowbridge, Rasleen begins a desperate
                  search for the truth, even if it means ruining her future.
                </p>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>;
}